export var RecipientHeadingEnum;
(function (RecipientHeadingEnum) {
    RecipientHeadingEnum["name"] = "Name";
    RecipientHeadingEnum["surname"] = "Surname";
    RecipientHeadingEnum["designation"] = "Designation";
    RecipientHeadingEnum["organisation"] = "Organisation";
    RecipientHeadingEnum["telephone"] = "Telephone";
    RecipientHeadingEnum["email"] = "Email";
    RecipientHeadingEnum["defaultCommunicationMethod"] = "Communication method";
})(RecipientHeadingEnum || (RecipientHeadingEnum = {}));
